module.exports = __webpack_public_path__ + "static/media/dreamteam-player.0f8cba20.png";